import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useThemeContext } from '../../context/Theme';

import { Icon, Loading } from '../UI';
import { columnClassName } from './MarketList';

import { getLogo } from '../../helpers/functions';

import { AssetInfoParams } from './types';
import { useMarketsContext } from './MarketContext';

export const AssetInfoElement = ({
  asset,
  className = columnClassName,
  flexDirection = 'col',
  logoSize = 5,
  showFavorite = true,
  useNav = true,
}: AssetInfoParams) => {
  const [starLoading, setStarLoading] = useState(false);

  const navigate = useNavigate();

  const { theme } = useThemeContext();

  const {
    assetType,
    favoritesAssetsIds,
    filterFavourites,
    filterMerlin,
    filterPortfolio,
    handleStarClick,
  } = useMarketsContext();

  const filters: ('favourites' | 'portfolio' | 'merlin')[] = [];
  filterFavourites && filters.push('favourites');
  filterMerlin && filters.push('merlin');
  filterPortfolio && filters.push('portfolio');

  const filter = filters.length ? filters.join('-') : 'withoutFilter';

  const fillStar = asset && favoritesAssetsIds.includes(asset.id);

  const onStarClick = () => {
    setStarLoading(true);
    handleStarClick(asset.id).finally(() => {
      setStarLoading(false);
    });
  };

  return !asset ? (
    <></>
  ) : (
    <div className={className}>
      {showFavorite &&
        (starLoading ? (
          <Loading className="w-4 mx-1 pr-0.5" status={true} />
        ) : (
          <Icon
            className={`min-w-4 w-4 h-4 ml-1 mr-2 pr-0.5 cursor-pointer${
              theme === 'DARK' && !fillStar ? ' filter invert' : ''
            }`}
            fill={favoritesAssetsIds.includes(asset.id)}
            svgName={'star'}
            onClick={onStarClick}
          />
        ))}
      <img
        src={getLogo(assetType, asset.logo)}
        className={`
          w-${logoSize}
          h-${logoSize}
          rounded-full
          cursor-pointer
          ${!useNav && 'pointer-events-none'}
        `}
        alt={'logo'}
        onClick={() =>
          navigate(`/market/${asset.id}/${asset.type}/${filter}/overview`)
        }
      />
      <div
        onClick={() =>
          navigate(`/market/${asset.id}/${asset.type}/${filter}/overview`)
        }
        className={`
          flex
          flex-${flexDirection}
          pl-2
          ${flexDirection === 'row' && 'gap-2 items-center'}
          ${!useNav && 'pointer-events-none'}
          w-2/3
          cursor-pointer
        `}
      >
        <div className={'font-medium uppercase truncate'}>{asset.symbol}</div>
        <div className={'text-xs text-grey-70 truncate'}>{asset.name}</div>
      </div>
    </div>
  );
};
